import { render, staticRenderFns } from "./DeleteCitationValidation.vue?vue&type=template&id=431af23a"
import script from "./DeleteCitationValidation.vue?vue&type=script&lang=ts"
export * from "./DeleteCitationValidation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports